/* ============================================================
   ShoLi — Toast Module
   Simple notification display (no external dependencies)
   ============================================================ */

type ToastApi = {
  show: (message: string, duration?: number) => void;
};

let el: HTMLElement | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

export function createToast(): ToastApi {
  function show(message: string, duration = 2500): void {
    if (!el) el = document.getElementById("toast");
    if (!el) return;
    const targetEl = el;
    targetEl.textContent = message;
    targetEl.classList.remove("hidden");
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => targetEl.classList.add("hidden"), duration);
  }

  return { show };
}
